var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHamburgerMenu = function SvgHamburgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 19",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.219c0-.746.578-1.386 1.385-1.386h18.23A1.4 1.4 0 0121.5 2.22c0 .807-.64 1.385-1.385 1.385H1.885C1.086 3.604.5 3.018.5 2.22zM.5 9.51c0-.745.578-1.385 1.385-1.385h14.73A1.4 1.4 0 0118 9.511c0 .807-.64 1.385-1.385 1.385H1.885C1.086 10.896.5 10.31.5 9.511zM.5 16.802c0-.745.578-1.385 1.385-1.385h18.23a1.4 1.4 0 011.385 1.385c0 .807-.64 1.386-1.385 1.386H1.885C1.086 18.188.5 17.6.5 16.802z",
    fill: "currentColor"
  })));
};
export default SvgHamburgerMenu;